
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * DataFeedStatus enum
 */
class DataFeedStatus {
  /**
   * Initialize enum with a given value
   * @param {DataFeedStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof DataFeedStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!DataFeedStatus}
   * @param {!DataFeedStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof DataFeedStatus)) {
      throw new TypeError('Instance of DataFeedStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!DataFeedStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!DataFeedStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === DataFeedStatus.OFFLINE.value) {
      return 'OFFLINE'
    }
    if (this.value === DataFeedStatus.LOCAL_ONLINE.value) {
      return 'LOCAL_ONLINE'
    }
    if (this.value === DataFeedStatus.REMOTE_ONLINE.value) {
      return 'REMOTE_ONLINE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!DataFeedStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!DataFeedStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!DataFeedStatus} Created enum
   */
  static fromObject (other) {
    return new DataFeedStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
DataFeedStatus.OFFLINE = new DataFeedStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
DataFeedStatus.LOCAL_ONLINE = new DataFeedStatus(0 + 1)
// noinspection PointlessArithmeticExpressionJS
DataFeedStatus.REMOTE_ONLINE = new DataFeedStatus(0 + 2)

export { DataFeedStatus };

/**
 * Fast Binary Encoding DataFeedStatus field model
 */
class FieldModelDataFeedStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelDataFeedStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelDataFeedStatus}
   * @param {DataFeedStatus=} defaults Default value, defaults is new DataFeedStatus()
   * @returns {!DataFeedStatus} Result value
   */
  get (defaults = new DataFeedStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new DataFeedStatus(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelDataFeedStatus}
   * @param {!DataFeedStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelDataFeedStatus };
